import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toHandlers as _toHandlers, mergeProps as _mergeProps, renderList as _renderList, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "Records per pagina: ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createBlock(_component_q_table, _mergeProps({
    class: "col-12",
    rows: _ctx.tableData,
    columns: _ctx.tableColumns,
    "row-key": _ctx.computedRowKey,
    separator: "horizontal",
    filter: _ctx.filter,
    "filter-method": _ctx.filterMethod,
    dense: "",
    flat: "",
    "binary-state-sort": "",
    color: "primary"
  }, _toHandlers(_ctx.rowClickHandler ? { 'row-click': _ctx.rowClickHandler } : {}), { ref: "bmTable" }), _createSlots({
    bottom: _withCtx((scope) => [
      _hoisted_1,
      _createVNode(_component_q_select, {
        modelValue: scope.pagination.rowsPerPage,
        "onUpdate:modelValue": ($event: any) => ((scope.pagination.rowsPerPage) = $event),
        borderless: "",
        "options-dense": "",
        "aria-label": `records per pagina: ${scope.pagination.rowsPerPage}`,
        options: [5, 10, 15, 20, 25, 50, 0],
        "option-label": (item) => (item === 0 ? 'Alle' : item)
      }, null, 8, ["modelValue", "onUpdate:modelValue", "aria-label", "option-label"]),
      _createElementVNode("span", null, _toDisplayString((
            (scope.pagination.page - 1) * scope.pagination.rowsPerPage +
            1
          ).toLocaleString("nl-NL")) + " - " + _toDisplayString(Math.min(
            scope.pagination.page * scope.pagination.rowsPerPage,
            _ctx.filter ? _ctx.filteredRowCount : (_ctx.tableData ? _ctx.tableData.length : 0),
          ).toLocaleString("nl-NL")) + " van " + _toDisplayString(_ctx.filter
            ? _ctx.filteredRowCount.toLocaleString("nl-NL")
            : (_ctx.tableData ? _ctx.tableData.length : 0).toLocaleString("nl-NL")), 1),
      (scope.pagesNumber > 2)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            icon: "first_page",
            color: "primary",
            round: "",
            dense: "",
            flat: "",
            disable: scope.isFirstPage,
            onClick: scope.firstPage,
            "aria-label": "Ga naar eerste pagina"
          }, null, 8, ["disable", "onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_btn, {
        icon: "chevron_left",
        color: "primary",
        round: "",
        dense: "",
        flat: "",
        disable: scope.isFirstPage,
        onClick: scope.prevPage,
        "aria-label": "Ga naar vorige pagina"
      }, null, 8, ["disable", "onClick"]),
      _createVNode(_component_q_btn, {
        icon: "chevron_right",
        color: "primary",
        round: "",
        dense: "",
        flat: "",
        disable: scope.isLastPage,
        onClick: scope.nextPage,
        "aria-label": "Ga naar volgende pagina"
      }, null, 8, ["disable", "onClick"]),
      (scope.pagesNumber > 2)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 1,
            icon: "last_page",
            color: "primary",
            round: "",
            dense: "",
            flat: "",
            disable: scope.isLastPage,
            onClick: scope.lastPage,
            "aria-label": "Ga naar laatste pagina"
          }, null, 8, ["disable", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (_ctx.downloadable)
      ? {
          name: "top-left",
          fn: _withCtx(() => [
            _createVNode(_component_q_btn, {
              class: "assistive-button btn-download",
              label: "Download CSV",
              "no-caps": "",
              flat: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.download(_ctx.tableData, _ctx.tableColumns))),
              "aria-label": "Download CSV"
            })
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.searchable)
      ? {
          name: "top-right",
          fn: _withCtx(() => [
            _createVNode(_component_q_input, {
              borderless: "",
              dense: "",
              debounce: "300",
              modelValue: _ctx.filter,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter) = $event)),
              "aria-label": "Zoekveld",
              placeholder: "Zoeken binnen tabel"
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, { name: "search" })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          key: "1"
        }
      : undefined,
    _renderList(_ctx.$slots, (_, slot) => {
      return {
        name: slot,
        fn: _withCtx((scope) => [
          _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope)))
        ])
      }
    })
  ]), 1040, ["rows", "columns", "row-key", "filter", "filter-method"]))
}